import React, { Fragment, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import * as Yup from 'yup';
import { Formik } from 'formik';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    Paper,
    FormLabel,
    List,
    Checkbox,
    ListItem,
    ListItemAvatar,
    Avatar,
    Icon,
    ListItemText,
    ListItemIcon,
} from '@material-ui/core';

const ColorCheckbox = withStyles({
    root: {
        marginLeft: 0,
        color: colors.blue[400],
        '&$checked': {
            color: colors.blue[500],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);


const useStyles = makeStyles((theme) => ({
    root: {
    },
    lists: {
        minHeight: 400,
        maxHeight: 400,
        overflow: 'auto'
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    }
}));

import { MdOutlineMapsHomeWork } from "react-icons/md";

const CreateInfra = ({ item, open, closeCreation, createValues, dependencies, checked, handleToggle }) => {

    const classes = useStyles();

    const [openChangeImageDialog, setOpenChangeImageDialo] = useState(false);

    const openChangeImage = (item) => {
        setOpenChangeImageDialo(true);
    }

    const closeChangeImageDialog = () => {
        setOpenChangeImageDialo(false);
    }

    const clearImage = (values) => {

    }

    const next = (values) => {

    }

    const previous = (values) => {

    }

    const infraNotFoundIn = (infra, infrasUnidade) => {
        var show = true;
        for (let index = 0; index < infrasUnidade.length; index++) {
            const element = infrasUnidade[index];
            if (element.infraEstrutura.id == infra.id) {
                show = false;
            }
        }
        return show;
    }

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Infraestrutura
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({

                            })
                        }
                        onSubmit={(values, formik) => {
                            createValues(values);
                            formik.setSubmitting(false);
                        }}

                    >

                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>


                                <Paper variant="outlined" rounded fullWidth  >
                                    <FormControl component="fieldset" fullWidth  >
                                        <FormLabel style={{ padding: 10 }} >
                                            <b>Mais Infraestruturas</b>
                                        </FormLabel>

                                        <Divider></Divider>

                                        <List dense button component={PerfectScrollbar} className={classes.lists} >
                                            {dependencies.infras.map((infra, index) => {
                                                return (
                                                    (infraNotFoundIn(infra, dependencies.infrasUnidade)) ?
                                                        <ListItem key={index} autoFocus={true}>
                                                            <ListItemIcon>
                                                                <ColorCheckbox
                                                                    edge="end"
                                                                    onChange={handleToggle(infra.id, 'infras')}
                                                                    checked={checked.indexOf(infra.id) != -1}
                                                                    inputProps={{ 'aria-labelledby': infra.id }}
                                                                />
                                                            </ListItemIcon>
                                                            <ListItemAvatar>
                                                                <Avatar
                                                                    className={classes.avatar}
                                                                >
                                                                    {<Icon component={MdOutlineMapsHomeWork} style={{ color: colors.cyan[400] }} ></Icon>}
                                                                </Avatar>
                                                            </ListItemAvatar>
                                                            <ListItemText id={infra.id} primary={infra.nome} secondary={(infra.tipo) ? `(` + infra.tipo.nome + `)` : ''} />
                                                        </ListItem>
                                                        : ""
                                                );
                                            })}

                                        </List>
                                    </FormControl>
                                </Paper>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Adicionar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeCreation() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default CreateInfra;
